import React from "react";
export default function JsonViewer({
                                       title = "JSON",
                                       data = {},
                                       dark = true
                                   }) {
    const formatJson = () => {
        try {
            if (typeof data === "string")
                return data;
            return JSON.stringify(data, null, 4);
        } catch {
            return "";
        }
    };
    return (
        <div className="card shadow-sm mt-3">

            <div className="card-header">

                <strong>{title}</strong>

            </div>

            <div

                className={
                    dark ?
                        "abdm-json-dark"
                        :
                        "abdm-json-light"
                }

            >

                <pre className="m-0">

                    {formatJson()}

                </pre>

            </div>

        </div>
    );
}